import { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { LINK_WHICH_NUMBER_IS_RIGHT_FOR_MY_NEEDS } from 'shared/constants/links'
import { ITabsEnum } from 'entities/Phone/types'
import { ChooseNumberTabs } from 'entities/Phone/ui/ChooseNumberTabs/ChooseNumberTabs'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type GetNumberModalStore } from 'entities/Phone/ui/GetNumberModal/store/GetNumberModalStore'

export type IGetNumberModalContentDefaultProps = {
  store: GetNumberModalStore
}

export const GetNumberModalContentDefault: FC<IGetNumberModalContentDefaultProps> = observer(
  ({ store }) => {
    const { organizationStore } = useEntitiesContext()
    const { chooseNumberStore, addNumberAlertProps, editAnswersHandler } = store

    useEffect(() => {
      if (organizationStore.isSinchNumberVendor) {
        chooseNumberStore.setHideTab(ITabsEnum.TOLL_FREE)
      }
    }, [])

    return (
      <div aria-label={getAriaLabel('GetNumberModalContent')}>
        <Alert
          marginBottom={24}
          item={{
            type: 'infoLight',
            title: 'Get your business number',
            desc: chooseNumberStore.alertDescription,
          }}
          rightActions={[
            {
              variant: 'link',
              type: 'primary',
              text: 'Learn more',
              link: LINK_WHICH_NUMBER_IS_RIGHT_FOR_MY_NEEDS,
            },
          ]}
        />
        <ChooseNumberTabs
          alertProps={addNumberAlertProps}
          store={chooseNumberStore}
          editAnswers={editAnswersHandler}
          onClose={store.closeModal}
        />
      </div>
    )
  }
)
